import React from "react";
import {translate} from '../../i18n/translate.js';
import styles from "../../css/summary/summary.less";

class SummaryPaymentPlan extends React.Component {
    render() {
        return (
            <div className="" name="joinSummaryPaymentPlan">
                <div className="summary-section-title">
                    {translate("Payment Plan")}
                </div>
                <div className="summary-content">
                    {this.props.paymentPlan.title}
                </div>
            </div>
        );
    }
}

export default SummaryPaymentPlan;



// WEBPACK FOOTER //
// ./src/components/summary/SummaryPaymentPlan.js